module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-miniature-wrapper overflow-hidden"
  }, [_c('div', {
    staticClass: "user-miniature-picture-wrapper"
  }, [_c('img', {
    staticClass: "user-miniature-picture",
    attrs: {
      "src": _vm.user.picture_url,
      "title": _vm.user_full_name
    }
  })]), (!_vm.options || !_vm.options.only_picture) ? _c('div', {
    staticClass: "user-miniature-name overflow-ellipsis"
  }, [_vm._v(_vm._s(_vm.user_name))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d2462a8a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/users/miniature.vue
// module id = 1219
// module chunks = 1